import { render, staticRenderFns } from "./UserScoreManage.vue?vue&type=template&id=c4326e42&scoped=true&"
import script from "./UserScoreManage.vue?vue&type=script&lang=js&"
export * from "./UserScoreManage.vue?vue&type=script&lang=js&"
import style0 from "./UserScoreManage.vue?vue&type=style&index=0&id=c4326e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4326e42",
  null
  
)

export default component.exports